import React from 'react';
import FileShield from '../assets/images/FileShield.svg';

export default () => {
  return <img src={FileShield} alt="" />;
};
 